import { useLocation } from "react-router-dom";

interface ModuleContext {
  isOneClick: boolean;
  isValuationReport: boolean;
  isValuationPackage: boolean;
  isOutlierShield: boolean;
  isSettings: boolean;
}

export const useModuleContext = (): ModuleContext => {
  const location = useLocation();

  const isOneClick = location.pathname.startsWith("/oneclick");
  const isValuationReport = location.pathname.startsWith("/valuation_report");
  const isValuationPackage = location.pathname.startsWith("/valuations");
  const isOutlierShield = location.pathname.startsWith("/outlier-shield");
  const isSettings = location.pathname.startsWith("/settings");

  return {
    isOneClick,
    isValuationReport,
    isValuationPackage,
    isOutlierShield,
    isSettings,
  };
};
